import axiosInstance from "../../../../axiosInstance";
import { toast } from "react-toastify";
import { HRMS_FINANCE_API_URL } from "../../../Constants/baseConstant";
import { getUserData } from "../../Base/helper/baseFunctions";

export const GetEmployeePaySlipHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/finance/getEmployeePaySlip`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data.domain,
            employee_id: params.employee_id,
            month: params?.month,
            year: params?.year
        }
    })
        .then(res => {
            return { message: "Pay Slip Generated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            if (err?.response?.data?.error?.[0]?.message !== "Payroll has not been generated for this employee for selected month. Head to Pay Summary Report to generate payroll") {
                toast.dismiss();
                toast.error(err?.response?.data?.error?.[0]?.message)
            }
            return { message: "Error", hasError: true, data: err?.response?.data }

        })
}
export const GetDailyWagesEmployeePaySlipHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/finance/getDailyWagesEmployeePaySlip`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data.domain,
            employee_id: params.employee_id,
            month: params?.month,
            year: params?.year
        }
    })
        .then(res => {
            return { message: "Pay Slip Generated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            if (err?.response?.data?.error?.[0]?.message !== "Payroll has not been generated for this employee for selected month. Head to Pay Summary Report to generate payroll") {
                toast.dismiss();
                toast.error(err?.response?.data?.error?.[0]?.message)
            }
            return { message: "Error", hasError: true, data: err?.response?.data }

        })
}